"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errorType = exports.errorItemType = exports.deviceType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _translations = require("./translations");
var _images = require("./images");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const errorItemType = exports.errorItemType = _propTypes.default.shape({
  displayNameId: _propTypes.default.number
});
const errorType = exports.errorType = _propTypes.default.arrayOf(errorItemType);
const deviceType = exports.deviceType = _propTypes.default.shape({
  building: _propTypes.default.arrayOf(_propTypes.default.string),
  displayNameId: _propTypes.default.arrayOf(_propTypes.default.number),
  displayNameIdColumn: _propTypes.default.arrayOf(_propTypes.default.number),
  equipmentId: _propTypes.default.string,
  equipmentName: _translations.translationValueType,
  equipmentType: _propTypes.default.string,
  error: errorType,
  hasimages: _propTypes.default.arrayOf(_images.hasimagesType),
  status: _propTypes.default.string,
  thingDeviceAddress: _propTypes.default.number,
  thingInfoComment: _translations.translationValueType,
  thingLoopType: _propTypes.default.string,
  thingNodeSerialNumber: _propTypes.default.string,
  thingPDID: _propTypes.default.string,
  thingPDIDDevice: _propTypes.default.string,
  thingPaulProductCode: _propTypes.default.string,
  thingProductDisplayClassification: _propTypes.default.string,
  thingSectionType: _propTypes.default.string,
  thingtaxvdi3805x810x8: _propTypes.default.string,
  thresholds: _propTypes.default.shape({
    [_propTypes.default.oneOf(['max', 'min'])]: _propTypes.default.shape({
      value: _propTypes.default.number,
      type: _propTypes.default.string
    })
  }),
  timestamp: _propTypes.default.number
});